var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-undefeated"},[_c('img',{staticClass:"c-undefeated__img",attrs:{"src":require("@/assets/15_0.png"),"alt":"15 - 0"}})])}]

export { render, staticRenderFns }